import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GenericRichTextDirective } from '@core/jss-utils';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import {
  JssModule,
  type RichTextField,
  type TextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'essent-order-overview-budget-bill-cost',
  templateUrl: './order-overview-budget-bill-cost.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    GenericRichTextDirective,
    ToolTipComponent,
    RoundedCurrencyPipe,
  ],
})
export class OrderOverviewBudgetBillCostComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() monthlyAmountLabel!: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() monthlyAmountTooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() monthlyAmount? = 0;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() budgetBillLabel!: RichTextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() budgetBillTooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() budgetBillAmount? = 0;
}
